import { useEffect, useState } from 'react';

/**
 * Tracks a DOM ref's getBoundingClientRect, refreshing on scroll, resize and
 * via ResizeObserver. Used by popovers that need viewport coordinates to
 * position themselves above stacking-context-trapped pages.
 */
export const useAnchorRect = (ref, active) => {
  const [rect, setRect] = useState(null);

  useEffect(() => {
    if (!active) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const update = () => setRect(el.getBoundingClientRect());
    update();

    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);

    return () => {
      ro.disconnect();
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
    };
  }, [ref, active]);

  return rect;
};

export default useAnchorRect;
